<template>
  <div class="grid grid-pad box-size text-dark" style="padding-top: 10px">
    <div class="col-1-1 box-size">
      <div class="students-container">
        <div class="students-container__header">
          <div class="students-container__header__left">
            <h1>{{ $t('vue2.students.students') }}</h1>
            <ChangeSchoolYear :whiteTheme="true"></ChangeSchoolYear>
          </div>
          <div class="students-container__header__right feide-import">
            <div class="feide-import" v-if="isFeideImportActive">
              <img id="feide-logo" :src="feideLogo"/>
              <p class="marg-1-right"><span class="text-explainer">{{ $t('vue2.students.latest_updated') }}:</span>
                {{ lastUpdateFromFeide }}</p>
              <button class="marg-1-right bttn--is-import" style="width: 120px;height: 34px;" @click="updateFromFeide">
                <span v-if="!isImporting">{{ $t('vue2.students.import_students') }}</span>
                <Loader v-else bg-color="#f6f7f8" style="margin: 0; width: 20px;height: 20px;"></Loader>
              </button>
            </div>
            <CreateStudents></CreateStudents>
          </div>
        </div>
        <div class="students">
          <div class="students__col students__col1">
            <div class="students__col__header">
              <h4>{{ $t('vue2.students.groups') }}</h4>
            </div>
            <div class="students__col__body" :style="bodyStyleObj">
              <Loader v-if="isLoading" bg-color="#fff"></Loader>
              <ul v-else>
                <li class="students__filters__filter"
                    @click="setTheActiveFilter('')"
                    :class="{'students__filters__filter--active': isTheActiveFilter('')}">
                  <div>
                    {{ $t('vue2.students.all') }}
                  </div>
                  <div><span class="icon-user"></span> {{ students.length }}</div>
                </li>
                <li class="students__filters__filter"
                    @click="setTheActiveFilter('filter__activatedStudents')"
                    :class="{'students__filters__filter--active': isTheActiveFilter('filter__activatedStudents')}">
                  <div>
                    {{ $t('vue2.students.activated_schedules') }}
                  </div>
                  <div><span class="icon-user"></span> {{ studentsActivated.length }}</div>
                </li>
                <li class="students__filters__filter"
                    @click="setTheActiveFilter('filter__students_without_groups')"
                    :class="{'students__filters__filter--active': isTheActiveFilter('filter__students_without_groups')}">
                  <div>
                    {{ $t('vue2.students.without_group') }}
                  </div>
                  <div><span class="icon-user"></span> {{ studentsWithoutKlasses.length }}</div>
                </li>
                <li class="students__filters__filter students__filters__filter__title">{{
                    localActivatedSchoolYear.name
                  }}
                </li>
                <li class="students__filters__filter"
                    ref="droppable_elements"
                    @click="setTheActiveFilter(klass.id)"
                    v-for="klass in klassCalendars"
                    :class="{'students__filters__filter--active': isTheActiveFilter(klass.id)}"
                    @dragover.prevent
                    @dragenter.prevent="dragEnter(klass, $event)"
                    @dragleave.prevent="dragLeave"
                    @drop.prevent="drop(klass, $event)">
                  <div>{{ klass.name }}</div>
                  <div><span class="icon-user"></span> {{ klass.students ? klass.students.length : 0 }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="students__col students__col2">
            <div class="students__col__header students__col__header__students">
              <h4>{{ $t('vue2.students.students') }}</h4>
            </div>
            <div class="students__col__body" ref="students_col1_body" :style="bodyStyleObj">
              <table class="students__table">
                <thead>
                <tr class="students__student students__student__header">
                  <th>
                    <span class="text-link" @click="toggleAll">
                      <template v-if="dragStudents.length < 1">{{ $t('vue2.tagging.select_all') }}</template>
                      <template v-else>{{ $t('vue2.tagging.unselect_all') }}</template>
                    </span>
                  </th>
                  <th class="d-label">{{ $t('vue2.students.groups') }} ({{ localActivatedSchoolYear.name }})</th>
                  <th class="d-label" v-if="isFeideActive">{{ $t('vue2.students.feide') }}</th>
                  <th class="d-label">{{ $t('vue2.students.to_be_scheduled') }}</th>
                </tr>
                </thead>
                <Loader v-if="isLoading" bg-color="#fff"></Loader>
                <tbody v-else>
                <tr
                  class="students__student"
                  :class="{'isSelected': student.v_isSelectedForDrag}"
                  v-for="student in filteredStudents" :key="student.id"
                  draggable="true"
                  @dragstart.stop="dragStart(student, $event)"
                  @dragend.stop="dragEnd(student, $event)"
                  @dragover.stop
                  @drop.prevent="drop(slot, $event)"
                  @click="setTheActiveStudent(student)">
                  <td>
                    <div class="name-and-checkbox">
                      <div class="icon__bg-circle" @click.stop="setStudentsSelectedForDrag(student)">
                        <div class="d-checkbox" :class="{'d-checkbox--active': false}"></div>
                      </div>
                      {{ student.name }}
                    </div>
                  </td>
                  <td>
                <span v-for="(klass, key) in student.v_klasses"><span v-if="key !== 0">, </span>
                  {{ klass.name }}</span>
                  </td>
                  <td v-if="isFeideActive">
                    {{ student.custom_data && student.custom_data.feide ? student.custom_data['feide'] : '' }}
                  </td>
                  <td>
                    <div class="d-toggle" :class="{'d-toggle--active': !student.archived_at}"
                         @click.stop="toggleStudentArchived(student)"></div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <DModal
          v-if="theActiveStudent"
          :isBgOverlay="true"
          :showClose="false"
          @close="closeModal">
          <div slot="insertComponent" class="doc-modal">
            <div class="doc-modal__header">
              <h2>{{ theActiveStudent.name }}</h2>
              <div class="doc-modal__close icon__bg-circle" @click="closeModal">
                <span class="icon-cross2"></span>
              </div>
            </div>
            <div class="doc-modal__body">
              <div class="d-input-group marg-1-bottom">
                <label class="d-label">{{ $t('vue2.students.name') }}</label>
                <input type="text" class="d-input" @keyup="isEditStudentChanges = true" v-model="editName">
              </div>
              <div class="d-input-group marg-1-bottom" v-if="isFeideActive">
                <label class="d-label">{{ $t('vue2.students.feide') }}</label>
                <input type="text" class="d-input" @keyup="isEditStudentChanges = true" v-model="editFeide">
              </div>
              <div class="d-input-group">
                <label class="d-label marg-05-bottom">{{ $t('vue2.students.groups') }}</label>
                <div class="doc-modal__student__klasses__no-klasses"
                     v-if="getStudentRelations(theActiveStudent).length < 1">
                  <p>{{ $t('vue2.students.has_no_groups') }}</p>
                </div>
                <ul class="doc-modal__student__klasses">
                  <li class="doc-modal__student__klasses__klass"
                      :class="{'klass--is-danger': isHoverOnKlass}"
                      v-for="(klass, key) in getStudentRelations(theActiveStudent)">
                    <div>{{ klass.name }}</div>
                    <div @click="removeFromKlass(klass)" @mouseenter="isHoverOnKlass = true"
                         @mouseout="isHoverOnKlass = false" class="text-link">{{ $t('vue2.students.remove') }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="doc-modal__footer">
              <div>
                <button class="hint--right bttn--warning"
                        :aria-label="$t('vue2.students.delete_student')"
                        @click="isEditStudentConfirmation = true">
                  <span class="icon-bin"></span>
                </button>
              </div>
              <transition name="fadeInUp">
                <div v-if="isEditStudentChanges">
                  <button class="bttn submit-button" style="width: 120px" @click="submitModal">{{
                      $t('vue2.common.save')
                    }}
                  </button>
                </div>
              </transition>
            </div>
          </div>
        </DModal>
        <ModalConfirmation
          v-if="isEditStudentConfirmation"
          @close="closeModal"
          @confirm="deleteStudent"
        ></ModalConfirmation>
      </div>
    </div>
    <div ref="customdrag" class="d-custom-drag" style="display: none">
      <span class="icon-user"></span> {{ $t('vue2.common.add') }} {{ dragStudents.length }}
      <template v-if="dragStudents.length === 1"> {{ $t('vue2.students.student') }}</template>
      <template v-else> {{ $t('vue2.students.students') }}</template>
    </div>
  </div>
</template>

<script>
import feideLogo from '../../assets/img/integrations/feide.png'
import Loader from '../common/Loader'
import DModal from '../common/DModal'
import eventbus from '../../eventbus'
import CreateStudents from '../CreateCalendars/CreateStudents/CreateStudents'
import ModalConfirmation from '../Modals/ModalConfirmation'
import moment from 'moment'
import Spinner from '../common/Spinner'
import docendo from '../../docendo'
import ChangeSchoolYear from '../School/ChangeSchoolYear'

export default {
  components: {ChangeSchoolYear, Spinner, ModalConfirmation, Loader, DModal, CreateStudents},
  data () {
    return {
      theActiveFilter: 'filter__activatedStudents',
      feideLogo: feideLogo,
      dragStudents: [],
      dragEvt: null,
      theActiveStudent: null,
      isHoverOnKlass: false,
      editName: '',
      editFeide: '',
      isEditStudentChanges: false,
      isEditStudentConfirmation: false,
      theLatestFeideImport: null,
      isImporting: false,
      offsetTop: 0
    }
  },
  computed: {
    bodyStyleObj () {
      const offsetHeight = this.offsetTop + 20
      return {
        overflow: 'auto',
        maxHeight: `calc(100vh - ${offsetHeight}px)`
      }
    },
    localActivatedSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    isFeideActive () {
      return false
    },
    isFeideImportActive () {
      return false
    },
    lastUpdateFromFeide () {
      let ddate = moment().subtract(2, 'hour')
      return this.theLatestFeideImport ? moment(this.theLatestFeideImport).format('LLL') : moment(ddate).format('LLL')
    },
    isLoadingSchoolCalenders () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    isLoadingCalendarRelations () {
      return this.$store.state.isLoadingCalendarRelations
    },
    isLoading () {
      return this.isLoadingSchoolCalenders || this.isLoadingCalendarRelations
    },
    students () {
      return this.$store.getters.allStudentCalendars
    },
    studentsWithoutKlasses () {
      return this.students.filter(student => student.klasses.length === 0)
    },
    studentsActivated () {
      return this.students.filter(student => !student.archived_at)
    },
    filteredStudents () {
      let students = []
      if (this.theActiveFilter === '') {
        students = this.students
      } else if (this.theActiveFilter === 'filter__students_without_groups') {
        students = this.studentsWithoutKlasses
      } else if (this.theActiveFilter === 'filter__activatedStudents') {
        students = this.studentsActivated
      } else {
        students = this.students.filter(student => {
          const idx = student.klasses.indexOf(this.theActiveFilter)
          if (idx > -1) {
            return student
          }
        })
      }
      return students.map(stud => {
        const iSSelectedForDrag = this.dragStudents.findIndex(dragStudent => dragStudent.id === stud.id) > -1
        this.$set(stud, 'v_klasses', this.getStudentKlasses(stud))
        this.$set(stud, 'v_isSelectedForDrag', iSSelectedForDrag)
        return stud
      })
    },
    klassCalendars () {
      return this.$store.getters.klassCalendars
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    relations () {
      return this.$store.state.calendarRelations
    },
    schoolYears () {
      return this.$store.state.schoolYears
    },
    schoolYearsInHash () {
      return this.schoolYears.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    }
  },
  methods: {
    updateOffsetTop () {
      if (this.$refs.students_col1_body) {
        this.offsetTop = this.$refs.students_col1_body.getBoundingClientRect().top
      }
    },
    setStudentsSelectedForDrag (student) {
      const idx = this.dragStudents.findIndex(dragStudent => dragStudent.id === student.id)
      if (idx < 0) {
        this.dragStudents.push(student)
      } else {
        this.dragStudents.splice(idx, 1)
      }
    },
    getSchoolYearName (klass) {
      const schoolYearId = this.allCalendarsInHash[klass.id] && this.allCalendarsInHash[klass.id].school_year_id ? this.allCalendarsInHash[klass.id].school_year_id : null
      return this.schoolYearsInHash[schoolYearId] ? '(' + this.schoolYearsInHash[schoolYearId].name + ')' : ''
    },
    getLatestFeideUpdate () {
      let latestDate = this.$helpers.getLocalStorage('feideUpdate')
      if (latestDate) {
        this.theLatestFeideImport = latestDate
      }
    },
    updateFromFeide () {
      this.isImporting = true
      this.$helpers.setLocalStorage('feideUpdate', moment().format('YYYY-MM-DD HH:mm'))
      setTimeout(_ => {
        this.getLatestFeideUpdate()
        this.isImporting = false
      }, 2500)
    },
    setTheActiveStudent (student) {
      this.theActiveStudent = student
      this.editName = student.name
      this.editFeide = student.custom_data['feide'] ? student.custom_data['feide'] : ''
    },
    closeModal () {
      this.theActiveStudent = null
      this.isEditStudentChanges = false
      this.isEditStudentConfirmation = false
    },
    getStudentKlasses (student) {
      if (student.klasses) {
        return student.klasses.filter(klassCalId => this.allCalendarsInHash[klassCalId] && this.allCalendarsInHash[klassCalId].school_year_id && (this.allCalendarsInHash[klassCalId].school_year_id === this.localActivatedSchoolYear.id)).map(calId => this.allCalendarsInHash[calId])
      } else {
        return []
      }
    },
    getStudentRelations (student) {
      if (student.calRelations) {
        return student.calRelations.filter(calRel => this.allCalendarsInHash[calRel.other_calendar_id]).map(relation => {
          if (this.allCalendarsInHash[relation.other_calendar_id].name) {
            var objRelation = {
              id: relation.id,
              name: this.allCalendarsInHash[relation.other_calendar_id].name
            }
            return objRelation
          }
        })
      } else {
        return []
      }
    },
    setTheActiveFilter (filter) {
      this.theActiveFilter = filter
    },
    isTheActiveFilter (filter) {
      return this.theActiveFilter === filter
    },
    toggleAll () {
      if (this.dragStudents.length > 0) {
        this.dragStudents = []
      } else {
        this.dragStudents = []
        this.filteredStudents.forEach(student => {
          this.dragStudents.push(student)
        })
      }
    },
    dragStart (student, evt) {
      const idx = this.dragStudents.findIndex(dragStudent => dragStudent.id === student.id)
      if (idx < 0) {
        this.dragStudents.push(student)
      }
      this.dragEvt = evt
      this.dragEvt.target.classList.add('isDragging')
      const el = this.$refs.customdrag
      el.style.display = 'flex'
      evt.dataTransfer.setDragImage(el, 0, 0)
    },
    dragEnd () {
      if (this.dragStudents.length === 0) {
        return
      }
      this.dragEvt.target.classList.remove('isDragging')
      this.dragEvt.target.style.display = ''
      this.dragStudents = []
      this.dragEvt = null
      this.$refs.customdrag.style.display = 'none'
    },
    dragEnter (klass, evt) {
      if (this.dragStudents.length === 0) {
        return
      }
      evt.target.classList.add('isDragEnter')
    },
    dragLeave (evt) {
      if (this.dragStudents.length === 0) {
        return
      }
      evt.target.classList.remove('isDragEnter')
    },
    drop (klass) {
      if (this.dragStudents.length === 0) {
        return
      }
      this.addStudentsToKlass(this.dragStudents, klass)
      this.dragEnd()
      let elements = this.$refs.droppable_elements
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.remove('isDragEnter')
      }
    },
    addStudentsToKlass (students, klass) {
      students.forEach(student => {
        const idx = student.calRelations.findIndex(relation => relation.other_calendar_id === klass.id)
        if (idx > -1) {
          eventbus.toast = {text: this.$t('vue2.students.is_already_in_the_klass'), success: false}
        } else {
          var obj = {
            calendarId: student.id,
            otherCalendarId: klass.id,
            relation: 'student_of'
          }
          this.$store.dispatch('createRelation', obj)
        }
      })
    },
    removeFromKlass (relation) {
      this.$store.dispatch('deleteRelation', relation.id)
    },
    deleteStudent () {
      this.$store.dispatch('deleteCalendar', this.theActiveStudent.id)
      this.closeModal()
    },
    submitModal () {
      let calObj = {
        calendarId: this.theActiveStudent.id,
        changes: {
          name: this.editName,
          feide: this.editFeide
        }
      }
      this.$store.dispatch('updateCalendar', calObj)
      this.closeModal()
    },
    toggleStudentArchived (student) {
      const calId = student.id
      let archive = false
      if (!student.archived_at) {
        archive = true
      }
      let calObj = {
        calendarId: calId,
        changes: {archived: archive}
      }
      docendo.schoolCalendarsUpdate(student.school_id, calObj.calendarId, calObj.changes, success => {
        const updateObj = {
          id: success.id,
          name: success.name,
          archived_at: success.archived_at
        }
        this.$store.commit('updateSchoolCalendar', updateObj)
      }, failure => {
        console.log('failure', failure)
      })
    }
  },
  beforeMount () {
    this.getLatestFeideUpdate()
  },
  mounted () {
    this.$store.dispatch('readCalendarRelations')
    this.updateOffsetTop()
    window.addEventListener('resize', this.updateOffsetTop)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateOffsetTop)
  }
}
</script>


<style scoped>
@import "../../assets/css/variables.css";

.students {
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 7%);
  background: #fff;
  min-height: 80vh;
}

.students__col {
  border: 1px solid #d8d8d8;
  border-width: 1px 0 1px 1px;
  flex: 1;
}

.students__col.students__col2 {
  flex: 3;
  border-width: 1px 1px 1px 1px;
}

.students__col__header {
  padding: 1rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #1a1f36;
  height: 55px;
  text-transform: capitalize;
}

.students__col__header h4 {
  color: #728195;
}

.students__student {
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #e3e8ee;
}

.students__student td {
  vertical-align: middle;
}

.students__student:not(.students__student__header):hover {
  background: aliceblue;
  cursor: pointer;
}

.students__filters__filter {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.25s;
}

.students__filters__filter:hover {
  background-color: #f6f9fc;
}

.students__filters__filter.isDragEnter {
  background-color: #f6f9fc;
  transform: scale(0.95);
}

.students__filters__filter.students__filters__filter--active {
  background: aliceblue;
}

.students__col__header__students {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.students-container__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.students__table {
  width: 100%;
  border-collapse: collapse;
}

.students__table th, .students__table td {
  width: 25%;
  text-align: left;
  padding: 0.5rem 1rem;
}

.students__table td:first-child {
  padding: 0.5rem 0;
}

.name-and-checkbox {
  display: flex;
  align-items: center;
}

.d-label {
  font-size: 0.9rem;
  color: #728195;
  text-transform: uppercase;
}

#feide-logo {
  width: 50px;
  margin-right: 1rem;
}

.students-container__header__right {
  display: flex;
  align-items: center;
}

.feide-import {
  display: flex;
  align-items: center;
}

.doc-modal {
  min-width: 550px;
  max-width: 550px;
  border-radius: 4px;
}

.doc-modal h2 {
  color: var(--dark-blue);
}

.doc-modal__header {
  padding: 2.5rem 2rem;
  background: #ffffff;
  border-bottom: 1px solid var(--border-color);
  transition: background-color 0.5s;
  border-radius: 4px 4px 0 0;
  color: #ffffff;
}

.doc-modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 8px;
  font-size: 15px;
  cursor: pointer;
  transition: color 0.25s, background-color 0.25s;
  color: var(--dark-blue);
}

.doc-modal__body {
  padding: 2rem;
  max-height: calc(80vh);
  overflow-y: auto;
  border-radius: 4px;
}

.doc-modal__student__klasses {
  background: #ffffff;
  border: 1px solid #e3e8ee;
  border-radius: 4px;
}

.doc-modal__student__klasses__klass:first-child {
  border-radius: 4px 4px 0 0;
}

.doc-modal__student__klasses__klass:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 0;
}

.doc-modal__student__klasses__klass {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #e3e8ee;
  transition: background-color 0.25s;
}

.doc-modal__student__klasses__klass.klass--is-danger:hover {
  background-color: rgb(250 86 90 / 25%);
}

.doc-modal__student__klasses__klass:hover {
  background: aliceblue;
}

.doc-modal__student__klasses__klass .text-link {
  color: var(--blue);
  cursor: pointer;
  transition: color 0.25s;
}

.doc-modal__student__klasses__klass .text-link:hover {
  color: rgb(250 86 90 / 100%);
}

.marg-05-bottom {
  margin-bottom: 1rem;
}

.doc-modal__student__klasses__no-klasses {
  background-color: #ffffff;
  padding: 1rem;
  font-style: italic;
}

.d-input {
  padding: 9px;
}

.d-input-group .d-label {
  margin-bottom: 6px;
}

.doc-modal__footer {
  padding: 2rem;
  display: flex;
  justify-content: space-between;
}


.doc-modal__footer > div:nth-child(2) button {
  margin-left: 0.5rem;
}

.submit-button {
  box-shadow: 0 2px 2px rgb(0 0 0 / 10%);
}

.bttn--is-import {
  display: flex;
  align-items: center;
  justify-content: center;
}

.d-toggle {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
  top: 0px;
  background-color: #ccc;
  border-radius: 34px;
}

.d-toggle:before {
  content: "";
  position: absolute;
  left: 1px;
  top: 1px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .25), 0 0 1px 0 rgba(0, 0, 0, .26);
  z-index: 2;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background-color: white;
  transition: transform .4s;
}

.d-toggle.d-toggle--active {
  background-color: #468AD7;
  box-shadow: 0 0 1px #468ad7;
}

.d-toggle.d-toggle--active:before {
  transform: translateX(13px);
}

.students-container__header__left {
  display: flex;
  align-items: center;
}

.students-container__header__left h1 {
  margin-right: 1rem;
  text-transform: capitalize;
}

.students__filters__filter.students__filters__filter__title {
  border: 1px solid #d8d8d8;
  border-width: 1px 0;
  background: #f6f9fc;
  cursor: default;
  padding: 0.25rem 1rem;
}


.d-custom-drag {
  cursor: pointer !important;
  position: absolute;
  top: -1000px;
  background-color: var(--primary);
  width: 200px;
  height: 50px;
  font-size: 1rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 1rem 2rem;
  color: #ffffff;
  font-weight: bold;
  text-transform: uppercase;
}

.d-custom-drag > span {
  margin-right: 0.5rem;
}

.icon__bg-circle > .d-checkbox {
  margin-left: 0;
  border-color: #222222;
}

.icon__bg-circle > .d-checkbox:before,
.icon__bg-circle > .d-checkbox:after {
  background: transparent;
}

tr.isSelected .icon__bg-circle > .d-checkbox:before,
tr.isSelected .icon__bg-circle > .d-checkbox:after {
  background: #222222;
}

tr.isSelected {
  background-color: aliceblue;
}

.students__col__body {
  overscroll-behavior: contain;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// Students.vue?9476cfdc